import { apiCall } from './generated/gqlClient';

const getOffersByResourceApiRequest = async resourceId => {
  const query = `
    query getOffersByResource($resourceId: Int!) {
      getOffersByResource(resourceId: $resourceId) {
        id
        providerId
        serviceId
        name
        description
        startTime
        endTime
        duration
        capacity
        price
        model
        sessionLimit
        active
        orderIndex
        service {
          id
          name
          type
        }
        sessionsCounter
        entityType
      }
    }
  `;

  return apiCall({ query, variables: { resourceId: +resourceId } });
};

const getAllServicesForListApiRequest = async () => {
  const query = `
    query getAllServices {
      getAllServices {
        id
        svcTypeId
        svcGroupId
        providerId
        name
        resources {
          id
          name
        }
      }
    }
  `;

  return apiCall({ query });
};

const getServicesSubServicesClassesApiRequest = async () => {
  const query = `
    query getSimplfiedServicesSubServicesClasses {
      getSimplfiedServicesSubServicesClasses {
        services {
          id
          name
          type
        }
        subServices {
          id
          name
          serviceId
        }
        classes {
          id
          name
          serviceId
        }
      }
    }
  `;

  return apiCall({ query });
};

export { getAllServicesForListApiRequest, getOffersByResourceApiRequest, getServicesSubServicesClassesApiRequest };
